import { Component, EventEmitter, Input, Output } from '@angular/core';

// Fundo desfocado de uma aba que ainda exige autorização (ações 2 e 4). O modal "Autorizar acesso" abre por cima.
// O fundo é fictício de propósito: os dados reais só são buscados depois da autorização (o blur não esconde nada do DevTools).
// Clicar no fundo pede o modal de novo (caso o usuário tenha cancelado).
@Component({
  selector: 'app-fundo-bloqueado',
  templateUrl: './fundo-bloqueado.component.html',
  styleUrls: ['./fundo-bloqueado.component.scss']
})
export class FundoBloqueadoComponent {
  // Formato do fundo de exemplo: grade (relatório), formulário (cadastro) ou dashboard (cartões e gráficos)
  @Input() fundo: 'grade' | 'formulario' | 'dashboard' = 'grade';
  @Output() solicitar = new EventEmitter<void>();

  readonly linhasDeExemplo = Array.from({ length: 8 });
  readonly camposDeExemplo = Array.from({ length: 6 });
  readonly cartoesDeExemplo = Array.from({ length: 4 });
  // Alturas fixas das barras do gráfico de exemplo (em %), sem relação com dado real
  readonly barrasDeExemplo = [40, 65, 50, 80, 55, 70, 45, 60];
}
